import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Card, CardHeader, CardTitle, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Alert, AlertDescription } from '../components/ui/alert';

const LoginPage = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const { login, isAuthenticated, user } = useAuth();
  const navigate = useNavigate();
  
  useEffect(() => {
	  console.log('LoginPage useEffect - isAuthenticated:', isAuthenticated);
	  console.log('LoginPage useEffect - user:', user);
	  
	  if (isAuthenticated && user) {
		// Use setTimeout to ensure state is fully updated
		setTimeout(() => {
		  if (user.role === 'admin' || user.role === 'superadmin') {
			navigate('/admin', { replace: true });
		  } else {
			navigate('/', { replace: true });
		  }
		}, 100);
	  }
	}, [isAuthenticated, user, navigate]);

  const handleSubmit = async (e) => {
	  e.preventDefault();
	  setError('');
	  try {
		const result = await login(username.trim(), password.trim());
		if (result.success) {
		  // Force a hard redirect instead of using navigate
		  if (result.user.role === 'admin' || result.user.role === 'superadmin') {
			window.location.href = '/admin';
		  } else {
			window.location.href = '/';
		  }
		} else {
		  setError(result.error);
		}
	  } catch (err) {
		console.error('Login error:', err);
		setError(err.message || 'Login failed. Please try again.');
	  }
	};

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-50 to-orange-50">
      <Card className="w-full max-w-md">
        <CardHeader>
          <CardTitle>Login</CardTitle>
        </CardHeader>
        <CardContent>
          {error && (
            <Alert variant="destructive" className="mb-4">
              <AlertDescription>{error}</AlertDescription>
            </Alert>
          )}
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <Label htmlFor="username">Username</Label>
              <Input
                id="username"
                type="text"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                required
              />
            </div>
            <div>
              <Label htmlFor="password">Password</Label>
              <Input
                id="password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>
            <Button type="submit" className="w-full">
              Login
            </Button>
          </form>
        </CardContent>
      </Card>
    </div>
  );
};

export default LoginPage;